<template>
  <pipeline-layout>
    <!--Main Content-->
    <table-paginated
      ref="deadPipelineTable"
      :load-data="loadDeadRecords"
      :columns="columns"
      :per-page="50"
      :actions-width="100"
      empty-heading="No dead leads"
      entries-label="leads"
      is-empty-boxed
    >
      <template #emptyMessage>This is where the leads you are no longer pursuing reside. You can control the lead
        statuses that show here in the
        <router-link :to="{name: 'settings', params: {tab: 'pipeline'}}">Pipeline Settings</router-link>
      </template>

      <template v-slot:actions="items">
        <button-link @click="openRecordModal(items.row.id)">View</button-link>
      </template>
    </table-paginated>

    <!--Filters-->
    <template #filters>
      <dead-filters :refresh="refresh"></dead-filters>
    </template>
  </pipeline-layout>
</template>

<script>
import TablePaginated from "../../../../components/table/TablePaginated";
import PipelineLayout from "../../components/PipelineLayout";
import DeadFilters from "./components/DeadFilters";
import dates from "../../../../services/dates";
import router from "../../../../router";

export default {
  name: "DeadPipelineDesktop",
  components: {DeadFilters, PipelineLayout, TablePaginated},
  data() {
    const that = this;
    return {
      columns: [
        {
          label: "Status",
          display(row) {
            return that.getStatusLabel(row.current_status_id);
          }
        },
        {
          label: "Address",
          display(row) {
            return row.property.line_1;
          },
          isSensitiveDate: true,
        },
        {
          label: "City",
          display(row) {
            return row.property.city;
          },
          isSensitiveDate: true,
        },
        {
          label: "State",
          display(row) {
            return row.property.state;
          },
          isSensitiveDate: true,
        },
        {
          label: "Campaign",
          display(row) {
            return that.getCampaignLabel(row.campaign_id);
          }
        },
        {
          label: "Dead At",
          display(row) {
            // return that.formatDate(row.dead_at);
            return that.formatDate(row.entered_status_at);
          }
        },
      ],
    };
  },
  computed: {
    filters() {
      return this.$store.getters["deadState/filters"];
    }
  },
  methods: {
    openRecordModal(recordId) {
      router.replace({query: {lead: recordId}});
    },
    loadDeadRecords(query = "") {
      const queryString = `status=${this.filters.statuses}&campaign=${this.filters.campaigns}&source=${this.filters.sources}&` + query;
      return this.$api.records.getPipelineDeadRecords(queryString);
    },
    refresh() {
      return this.$refs.deadPipelineTable.queryData();
    },
    getCampaignLabel(campaignId) {
      let campaign = this.$store.getters.campaigns.find(campaign => campaign.id === campaignId);
      return campaign ? campaign.label : null;
    },
    getStatusLabel(statusId) {
      let status = this.$store.getters["pipeline/deadStatuses"].find(status => status.id === statusId);
      return status ? status.label : null;
    },
    formatDate(date) {
      return dates.formatAsDate(date);
    },
  },
};
</script>
